import React from "react";
import { IngestionJob } from "../../api/ingestionJob";
import { AddRemittanceAdvicesStep } from "./add-remittance-advices-step";
import { ConfirmRemittanceAdvicesDataStep } from "./confirm-remittance-advices-data-step";
import { InblockedRemittanceAdvicesDataStep } from "./inblocked-remittance-advices-data-step";

export const RemittanceAdvicesWorkflow = ({ isEdit, workflowStep, job, next, back, cancel, startOver, $refreshEvents }:
    { isEdit: boolean, workflowStep: number, job: IngestionJob, next, back, cancel, startOver, $refreshEvents }) => {

    const isAddRemittanceAdvicesEnabled = () => {
        if (isEdit) return false;
        return workflowStep === 1;
    }

    const isConfirmRemittanceAdvicesDataStepEnabled = () => {
        if (isEdit && workflowStep == 0) return true;
        return workflowStep === 2;
    }

    const isInblockedInvoicesDataStepEnabled = () => {
        if (isEdit && workflowStep == 1) return true;
        return workflowStep === 3;
    }

    return <>
        {isAddRemittanceAdvicesEnabled() && <AddRemittanceAdvicesStep job={job} next={next} back={back} cancel={cancel}/>}
        {isConfirmRemittanceAdvicesDataStepEnabled() && <ConfirmRemittanceAdvicesDataStep isEdit={isEdit} job={job} next={next} cancel={cancel} startOver={startOver} $refreshEvents={$refreshEvents} />}
        {isInblockedInvoicesDataStepEnabled() && <InblockedRemittanceAdvicesDataStep job={job} back={back} $refreshEvents={$refreshEvents} />}
    </>;
}
